import { render, staticRenderFns } from "./PlanoPagamentoModule.vue?vue&type=template&id=a54868ea"
import script from "./PlanoPagamentoModule.vue?vue&type=script&lang=js"
export * from "./PlanoPagamentoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports